import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import Modal from '../components/Modal';
import StatCard from '../components/StatCard';
import JadwalServisChart from '../components/JadwalServisChart';
import KendaraanDinasChart from '../components/KendaraanDinasChart';
import api from '../api/axiosConfig'; // Gunakan instance axios kita
import { showSuccessToast } from '../utils/alert';
import '../App.css'; 

const DashboardPage = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [totalKendaraan, setTotalKendaraan] = useState(0);
  const [totalJadwalServis, setTotalJadwalServis] = useState(0);
  const [loading, setLoading] = useState(true);

  const [upcomingServices, setUpcomingServices] = useState([]);
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  

  useEffect(() => {
    if (location.state?.message) {
      showSuccessToast(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const statsResponse = await api.get('/api/dashboard/stats');
        setTotalKendaraan(statsResponse.data.totalKendaraan);
        setTotalJadwalServis(statsResponse.data.totalJadwalServis);

        if (user && (user.role === 'operator' || user.role === 'superadmin')) {
          const reminderResponse = await api.get('/api/dashboard/operator-reminders');
          if (reminderResponse.data.length > 0) {
            setUpcomingServices(reminderResponse.data);
            setIsReminderModalOpen(true);
          }
        }
      } catch (error) {
        console.error("Gagal mengambil data dashboard:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [user]);

  return (
    <>
      <div className="dashboard-grid">
        {/* Kolom Kiri untuk Dua Grafik */}
        <div className="dashboard-charts">
          <div className="card"><JadwalServisChart /></div>
          <div className="card"><KendaraanDinasChart /></div>
        </div>

        <div className="dashboard-stats">
          <StatCard title="Jumlah Kendaraan" value={loading ? '...' : totalKendaraan} icon="🚗" />
          <StatCard title="Perawatan / Service" value={loading ? '...' : totalJadwalServis} icon="🔧" />
        </div>
      </div>
      <Modal 
        show={isReminderModalOpen} 
        onClose={() => setIsReminderModalOpen(false)} 
        title="Pengingat Jadwal Servis Mendatang"
        size="large"
      >
        <p style={{padding: '0 24px 20px 24px', marginTop: 0}}>Berikut adalah daftar kendaraan yang memiliki jadwal servis dalam 7 hari ke depan.</p>
        <div style={{padding: '0 24px 24px 24px'}}>
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Nomor Kendaraan</th>
                        <th>Jenis</th>
                        <th>Tanggal Servis</th>
                    </tr>
                </thead>
                <tbody>
                    {upcomingServices.map(service => (
                        <tr key={service._id}>
                            <td>{service.kendaraan?.nomorKendaraan || 'Kendaraan tidak ditemukan'}</td>
                            <td>{service.kendaraan?.jenis || 'N/A'}</td>
                            <td>{new Date(service.tanggal).toLocaleDateString('id-ID', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
      </Modal>
    </>
  );
};

export default DashboardPage;